import { reactive } from "@vue/composition-api";
import { AutocompleteResult } from "@/components/Autocomplete/autocomplete-id";

import { TemplateWorkOrder } from "@/store/modules/templateWorkOrders";
import { buildFormCommodityAutocomplete } from "@/models/Commodity";

interface hasTemplateId {
  template_id: string;
}

export interface FormTemplateWorkOrder {
  id: string;
  template_name: string;
  template_description: string;
  description: string;
  commodity_id: string;
  duration: number | string;
  duration_unit: string;
  cut_number: number;
  formCommodity: AutocompleteResult;
}

export function buildFormTemplateWorkOrder() {
  let { formCommodity } = buildFormCommodityAutocomplete();

  const formTemplateWorkOrder = reactive<FormTemplateWorkOrder>({
    id: "",
    template_name: "",
    template_description: "",
    description: "",
    commodity_id: "",
    duration: 0,
    duration_unit: "days",
    cut_number: 0,
    formCommodity: formCommodity,
  });

  const loadTemplateWorkOrderIntoForm = (
    two: TemplateWorkOrder,
    ftwo: FormTemplateWorkOrder,
  ) => {
    ftwo.id = two.id;
    ftwo.template_name = two.template_name;
    ftwo.template_description = two.template_description;
    ftwo.description = two.description;
    ftwo.commodity_id = two.commodity_id;
    ftwo.duration = two.duration;
    ftwo.duration_unit = two.duration_unit;
    ftwo.cut_number = two.cut_number;
    ftwo.formCommodity.label = two.commodity;
    ftwo.formCommodity.id = two.commodity_id;
  };

  return {
    formTemplateWorkOrder,
    loadTemplateWorkOrderIntoForm,
  };
}

export function buildFormTemplateWorkOrderAutocomplete() {
  let formTemplateWorkOrder = reactive<AutocompleteResult>({
    id: "",
    label: "",
  });

  let updateTemplateWorkOrder = (
    evt: AutocompleteResult,
    formTemplateWorkOrder: AutocompleteResult,
    formData: hasTemplateId,
  ) => {
    formTemplateWorkOrder.id = evt.id;
    formTemplateWorkOrder.label = evt.label;
    formData.template_id = evt.id;
  };

  return {
    formTemplateWorkOrder,
    updateTemplateWorkOrder,
  };
}
